// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T16:59:09.589Z
// Property: Brookbend Apartments (ID: 6767906449167015)
// Collections: 24 amenities, 17 floorplans (live), 31 photos, 43 POIs, 1 reviews, 8 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449167015",
  "property_external_id": "37441",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/harbor-club-apartments-newark-de/t9y06q9/",
  "property_google_business_url": "https://www.google.com/maps/place/Harbor+Club/data=!4m2!3m1!1s0x0:0x90c91b82a80f30ab?sa=X&ved=2ahUKEwi2jsaUnbmSAxUSJkQIHZlhBOsQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47668258328",
  "property_crm_software": null,
  "property_pm_software": "RealPage",
  "property_pm_info": "Property ID: 5618406",
  "property_status": null,
  "property_slug": "brookbend-apartments",
  "property_name": "Brookbend Apartments",
  "property_website_url": "https://www.livebrookbendapartments.com/",
  "property_domain": "https://www.livebrookbendapartments.com/",
  "property_address": "26 Cheswold Blvd",
  "property_full_address": "26 Cheswold Blvd, Newark, DE 19713",
  "property_address_1": "26 Cheswold Blvd",
  "property_address_2": "2a",
  "property_address_city": "Newark",
  "property_address_state": "DE",
  "property_address_zip_full": "19713-4135",
  "property_address_zip": "19713",
  "property_address_country": "US",
  "property_address_county": "New Castle County",
  "property_neighborhood_address": "Upper New Castle County",
  "property_address_latitude": "39.6874779",
  "property_address_longitude": "-75.6856054",
  "property_email": "brookbend@aionmanagement.com",
  "property_phone": "3029271191",
  "property_call_tracking_phone": "302-824-8387",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Brookbend Apartments in Newark, DE, where modern living meets comfort. Choose from one, two, or three-bedroom floor plans designed for your lifestyle. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and serene walking trails. Find your new home today—browse our availability or schedule a tour! ",
  "property_long_description": "Welcome to Brookbend Apartments, your gateway to modern living in the heart of Newark, DE. With a range of thoughtfully designed floor plans, including spacious one, two, and three-bedroom apartments, you'll find the perfect space to call home. Each residence features stylish amenities such as stainless steel appliances, walk-in closets, and high-speed internet access, ensuring comfort and convenience at every turn.\n\nAt Brookbend, we believe in providing a lifestyle filled with luxury and leisure. Our community boasts an impressive array of amenities, including a sparkling swimming pool, state-of-the-art fitness center, and a secluded picnic area complete with grills for hosting gatherings with friends and family. Enjoy our vibrant clubhouse and lounge, or take advantage of our business center and multi-use room for all your work and leisure needs.\n\nYour furry friends are welcome too! Take them to our dedicated pet play area or stroll along the scenic walking and biking trails that wind through our lush courtyards. Plus, with on-site laundry facilities, a package service, and a professional property manager always available, we've thought of everything to make your life easier.\n\nLocated in Newark, DE, Brookbend Apartments offers the ideal blend of comfort and community. Experience hassle-free living with added perks like a car charging station, maintenance on-site, and convenient Wi-Fi access. Don’t miss your chance to join our welcoming neighborhood.\n\nFind your new home today—browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd912-133e-764f-b387-32abc3d7292e.webp",
  "property_featured_image_media": {
    "alt_text": "Stainless steel dishwasher, electric stove, and microwave above a white countertop.",
    "public_id": "019fd912-133e-764f-b387-32abc3d7292e",
    "storage_key": "property/6767906449167015/019fd912-133e-764f-b387-32abc3d7292e.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "615",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.72357723577237",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $300 per pet.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. We require a refundable pet deposit of $350 per pet and monthly pet rent of $50 per pet.",
  "property_petpolicy_info": "We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $300 per pet.",
  "property_online_leasing_url": "https://9287864.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://brookbendapartments.loftliving.com/login",
  "property_apply_now_url": "https://www.livebrookbendapartments.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019e707c-18f6-75cd-acb1-3e662646b015.webp",
  "property_primary_logo_media": {
    "alt_text": "Brookbend Apartments logo.",
    "public_id": "019e707c-18f6-75cd-acb1-3e662646b015",
    "storage_key": "property/6767906449167015/019e707c-18f6-75cd-acb1-3e662646b015.webp",
    "width": 626,
    "height": 155
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019e707c-6179-7117-8fb4-1c81f8bc5c46.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Brookbend Apartments logo",
    "public_id": "019e707c-6179-7117-8fb4-1c81f8bc5c46",
    "storage_key": "property/6767906449167015/019e707c-6179-7117-8fb4-1c81f8bc5c46.webp",
    "width": 626,
    "height": 155
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019e707c-af2a-76dc-a2eb-382d753e077e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Harbor Club logo with a lighthouse inside an oval.",
    "public_id": "019e707c-af2a-76dc-a2eb-382d753e077e",
    "storage_key": "property/6767906449167015/019e707c-af2a-76dc-a2eb-382d753e077e.webp",
    "width": 626,
    "height": 155
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#e2903d",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "281 - 1071",
  "property_sqft_min": "281",
  "property_sqft_max": "1071",
  "property_price_range": "1949",
  "property_price_min": null,
  "property_price_max": "1949",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/livebrookbend",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ86d_dusAx4kRqzAPqIIbyZA",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/harbor-club-apartments-newark",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Brookbend Apartments",
  "property_home_romance_title": "Experience the Joy of Living in Your Perfect Apartment",
  "property_home_amenities_blurb": "At Brookbend Apartments in Newark, DE, your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like stainless steel appliances and walk-in closets. Enjoy on-site conveniences such as laundry facilities, a fitness center, and serene walking trails. Your perfect lifestyle starts here!",
  "property_home_floorplans_blurb": "Welcome to Brookbend Apartments in Newark, DE, where comfort meets convenience. Choose from our stylish one, two, and three-bedroom floor plans designed for every lifestyle. Embrace cozy living and vibrant community vibes—browse our available apartment homes today to find the perfect space that feels like home!",
  "property_home_gallery_blurb": "Welcome to Brookbend Apartments in Newark, DE, where your ideal living space awaits! Choose from spacious one-, two-, and three-bedroom floor plans, complemented by top-notch amenities like a sparkling pool, fitness center, and pet play area. Picture yourself enjoying vibrant community life amidst stunning courtyards and scenic trails!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Newark, Brookbend Apartments offers more than just stylish one-, two-, and three-bedroom homes. Embrace an active lifestyle with nearby parks, fitness clubs, and the University of Delaware. Let your adventures begin at local gems like the Bear Library and White Clay Creek State Park.",
  "property_home_reviews_blurb": "At Brookbend Apartments in Newark, DE, residents are thriving in spacious, elegant homes complemented by first-rate amenities. With glowing reviews highlighting the “amazing pool” and the “friendly, professional” staff, it’s clear why so many are proud to call this community home. Join us and experience the difference today!",
  "property_neighborhood_blurb": "At Brookbend Apartments in Newark, DE, you're surrounded by a vibrant tapestry of life. Unwind at nearby parks like White Clay Creek State Park or enjoy recreational activities at Delcastle Recreational Park. With educational institutions such as the University of Delaware and convenient access to fitness clubs, your ideal lifestyle awaits.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Brookbend Apartments in Newark, DE, every detail is designed for your comfort. From spacious one, two, and three-bedroom layouts to outstanding amenities like a fitness center, pool, and pet play area, your ideal lifestyle awaits. Enjoy community connections in our clubhouse or unwind in the serene courtyard. ",
  "property_applynow_blurb": "At Brookbend Apartments in Newark, DE, a harmonious blend of comfort and convenience awaits you. Choose from one, two, or three-bedroom plans, each featuring modern finishes and ample amenities. Enjoy an on-site fitness center, a sparkling pool, and a pet-friendly courtyard. Your new home is just a click away—lease online now!",
  "property_contactus_blurb": "At Brookbend Apartments in Newark, DE, your ideal home awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. If you have questions about our vibrant community, our friendly leasing team is here to help—reach out to us today!",
  "property_faqs_blurb": "At Brookbend Apartments in Newark, DE, we cater to diverse lifestyles with our thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Our FAQs page is your go-to resource for insights about our community, making it easy for you to find the perfect home that suits your needs.",
  "property_floorplans_blurb": "At Brookbend Apartments in Newark, DE, our thoughtfully designed floor plans cater to every lifestyle. Whether you're seeking a cozy one-bedroom retreat, a spacious two-bedroom haven, or a family-friendly three-bedroom layout, each option provides an inviting space to call home. Browse our available residences and envision your ideal living arrangement today!",
  "property_gallery_blurb": "At Brookbend Apartments in Newark, DE, vibrant living awaits you! Embrace stylish one, two, and three-bedroom floor plans, along with exceptional amenities like a refreshing pool, state-of-the-art fitness center, and pet-friendly play area. Picture yourself enjoying the serene courtyard or relaxing in the clubhouse. Your perfect home starts here!",
  "property_interactivemap_blurb": "Welcome to Brookbend Apartments in Newark, DE, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities, a vibrant clubhouse, and serene walking trails. Our interactive map allows you to easily preview available apartments and pricing—your perfect home awaits!",
  "property_pets_blurb": "Welcome to Brookbend Apartments in Newark, DE, where modern living meets comfort. Enjoy spacious interiors and vibrant community spaces, all while your furry friends join the fun. With a pet-friendly policy that accommodates cats and dogs, your new home here embraces every wag and purr, creating a welcoming haven for all.",
  "property_referafriend_blurb": "At Brookbend Apartments in Newark, DE, we know that great friends make great neighbors! With spacious one, two, and three-bedroom floor plans, you and your friends can find the perfect home together. Refer a friend today and build a vibrant community that enhances your living experience!",
  "property_residentaccess_blurb": "At Brookbend Apartments in Newark, DE, enjoy spacious one, two, and three-bedroom floor plans tailored for modern living. Our intuitive resident portal allows you to effortlessly manage your home—pay rent, schedule maintenance, and more—right at your fingertips. Elevate your living experience with us today!",
  "property_reviews_blurb": "At Brookbend Apartments in Newark, DE, residents rave, “the pool is amazing and the apartments are huge!” Enjoy impeccable grounds, 24-hour maintenance, and a friendly atmosphere. With convenient access to shopping and schools, it’s the perfect place for families. See what our residents have to say about living at our community!",
  "property_created_at": "1769557422184",
  "property_scheduletour_blurb": "At Brookbend Apartments in Newark, DE, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom homes—cater to every lifestyle. Schedule a tour today and hear firsthand from our residents about the unique charm and vibrant community that await you!",
  "property_thankyou_blurb": "Thank you for reaching out! At Brookbend Apartments in Newark, DE, we offer a variety of thoughtfully designed floor plans—one, two, and three bedrooms to suit your lifestyle. A team member will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "Welcome to Brookbend Apartments in Newark, DE, where comfort meets style! Choose from spacious one, two, or three-bedroom floor plans tailored for your lifestyle. Experience the inviting atmosphere and modern amenities through our immersive virtual tour. Your ideal home awaits—take the tour and envision your new life today!",
  "property_copyright": "2026 All Rights Reserved. Brookbend",
  "property_seo_title_home": "Apartments in Newark, DE 19713 | Brookbend Apartments",
  "property_seo_description_home": "Brookbend Apartments has 1, 2 and 3 bedroom apartments in Newark, DE 19713 with a swimming pool, fitness center, clubhouse and EV charging stations.",
  "property_seo_title_floorplans": "1, 2 and 3 Bedroom Apartments for Rent in Newark, DE",
  "property_seo_description_floorplans": "Find a layout that fits at Brookbend Apartments. Compare 1, 2 and 3 bedroom floor plans with walk-in closets, central air and select renovated kitchens.",
  "property_seo_title_amenities": "Pool, Gym and EV Charging at Brookbend Apartments",
  "property_seo_description_amenities": "Cool off in the pool, train at the fitness center and charge your EV on-site. Brookbend Apartments also has a clubhouse, dog run and BBQ areas.",
  "property_seo_title_gallery": "See Inside Brookbend Apartments | Newark, DE Photos",
  "property_seo_description_gallery": "Browse photos of Brookbend Apartments, from renovated kitchens and vinyl plank floors to the swimming pool, playgrounds and landscaped grounds.",
  "property_seo_title_virtualtours": "Tour Brookbend Apartments From Home | Virtual Tours",
  "property_seo_description_virtualtours": "Can't make it to Newark yet? Walk through Brookbend Apartments with a virtual tour and explore floor plans and amenities from your phone or laptop.",
  "property_seo_title_interactivemap": "Community Map of Brookbend Apartments in Newark, DE",
  "property_seo_description_interactivemap": "Get your bearings before move-in day. Use the Brookbend Apartments property map to find buildings, parking, the pool, clubhouse and playgrounds.",
  "property_seo_title_neighborhood": "Apartments Near Christiana Mall | Brookbend Apartments",
  "property_seo_description_neighborhood": "Live 1.5 miles from Churchmans Crossing Station at Brookbend Apartments, near Christiana Mall, the University of Delaware and White Clay Creek.",
  "property_seo_title_contact": "Contact Brookbend Apartments | 26 Cheswold Blvd, Newark",
  "property_seo_description_contact": "Call 302-824-8387 or stop by 26 Cheswold Blvd, Newark, DE 19713. The Brookbend Apartments leasing office is open Monday through Saturday.",
  "property_seo_title_faqs": "Questions About Renting at Brookbend Apartments",
  "property_seo_description_faqs": "Have questions about leasing, pets, amenities or move-in at Brookbend Apartments? Find quick answers about apartment living in Newark, DE here.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Newark, DE",
  "property_seo_description_reviews": "Join the Brookbend Apartments community in Newark, DE! Discover resident reviews and envision your vibrant lifestyle in our spacious homes.",
  "property_seo_title_applynow": "Apply Online | Newark, DE Apartments for Rent",
  "property_seo_description_applynow": "Found the one? Start your rental application at Brookbend Apartments online and take the next step toward your new apartment in Newark, Delaware.",
  "property_seo_title_residentaccess": "Brookbend Apartments Resident Portal | Pay Rent Online",
  "property_seo_description_residentaccess": "Brookbend Apartments residents can pay rent, submit maintenance requests and manage their account online through the resident portal, 24/7.",
  "property_seo_title_referafriend": "Refer A Friend | Brookbend Apartments",
  "property_seo_description_referafriend": "Share the joy of living at Brookbend Apartments in Newark, DE! Refer a friend and enjoy the perks of great neighbors and a vibrant community.",
  "property_seo_title_scheduletour": "Book a Tour of Brookbend Apartments in Newark",
  "property_seo_description_scheduletour": "Pick a time that works for you and see Brookbend Apartments in person. Walk through a home, check out the pool and meet our Newark leasing team.",
  "property_seo_title_privacy": "Privacy Policy | Brookbend Apartments",
  "property_seo_description_privacy": "Learn how Brookbend Apartments collects, uses and protects the personal information you share with us through this website.",
  "property_seo_title_accessibility": "Website Accessibility | Brookbend Apartments",
  "property_seo_description_accessibility": "Brookbend Apartments is committed to an accessible website for everyone. Read about our efforts and how to reach us if you need assistance.",
  "property_seo_title_sitemap": "Sitemap | Brookbend Apartments",
  "property_seo_description_sitemap": "Navigate Brookbend Apartments in Newark, DE effortlessly! Check out our sitemap to find the perfect home and embrace your vibrant community lifestyle today.",
  "property_seo_title_thankyou": "Thanks for Reaching Out | Brookbend Apartments",
  "property_seo_description_thankyou": "Thank you for contacting Brookbend Apartments! A member of our leasing team will reach out soon to assist you with your apartment search in Newark.",
  "property_seo_title_pets": "Bringing a Pet? Brookbend Apartments Pet Policy",
  "property_seo_description_pets": "Brookbend Apartments welcomes up to two pets per home. Review pet deposits, monthly pet rent and community guidelines before you move in.",
  "property_updated_at": "1793637718838",
  "amenities": [
    {
      "id": "custom_171b425e-7a70-411e-89cc-f7aea8c883fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77c9fa27-5e26-4b77-84fd-46a5e3f25e3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac33243a-85ee-4ab9-a069-5d98d8f88765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba3e209d-e930-45c1-9706-f6ad34d4dacc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4772bf1d-17cd-40e6-acbf-43b78fd56003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac996c53-124b-47ec-9748-1322f65ff674",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes Available*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b387b1b-5f58-4245-b6dc-658f83c81e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b864770d-19d2-4b7b-aab5-22ba53edee14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d17be797-ccf2-4e6e-979f-7c55537d8ca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_184fe6ad-58f9-4ee9-acd4-bb293591675b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Modern White Cabinets*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8c16adf-d86d-4683-a307-bf42aeb63862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11f5c221-c12f-427e-b65f-b156fc3e30ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Black Fixtures*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55475d4f-7036-4569-b86c-4e432bbf7b33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_894269e4-8081-4f81-af09-caaa2b53710a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b93b88c2-8919-4f44-bce5-158e85072bc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43fb23f1-602c-4202-bf34-ce1ab8d71ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Jogging Trail with Workout Stations",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_204e629b-57d1-45d9-976b-e12754598beb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "1.5 Miles from Churchmans Crossing Station",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72eb6270-e910-4dcd-a69d-0cf71ceb7e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "3.5 Miles from Christiana Mall",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd472074-907a-4e33-ba2b-e4ab3f426a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48348c6e-3d9b-47df-975c-05da640635ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Run",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_964ddfbf-85f6-491b-b53a-bf778841b014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic and BBQ Areas",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc304964-9f60-4a11-9d4a-262494a275ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Multiple Playgrounds",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f4e28c5-693f-4270-8f77-3d4ebb559207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Automated Package Center",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2aa0ad96-d5fa-4f58-bbc9-d7659f386faa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "external_id": "false",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3c5a0fdc-552f-42f5-adcb-403375bb4a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-3ab1-71d7-aaba-9c4f85cc1f04.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019fd91e-3ab1-71d7-aaba-9c4f85cc1f04",
        "storage_key": "property/6767906449167015/019fd91e-3ab1-71d7-aaba-9c4f85cc1f04.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/15-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-013-59eab5e4-1920w.jpg"
    },
    {
      "id": "custom_644b4aaa-40ec-4ebd-a966-f8a7416a4592",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-12e0-73bb-ac42-dcc3df9b74fc.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "019fd91e-12e0-73bb-ac42-dcc3df9b74fc",
        "storage_key": "property/6767906449167015/019fd91e-12e0-73bb-ac42-dcc3df9b74fc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "false",
      "link": "false",
      "alt_text": "false",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/14-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-012-2d29f99e-1920w.jpg"
    },
    {
      "id": "custom_534f816a-a80d-4cad-9810-7c70a2f3f29d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-3aef-72be-a614-dc0282f8001c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dining area.",
        "public_id": "019fd91e-3aef-72be-a614-dc0282f8001c",
        "storage_key": "property/6767906449167015/019fd91e-3aef-72be-a614-dc0282f8001c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and a breakfast bar. Adjacent dining area with a table and chairs.",
      "link": "false",
      "alt_text": "Brookbend Apartments Modern kitchen with stainless steel fridge, microwave, and stove; dining area visible in an open-plan space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/da345833e680b347ee096612cef86af9-1920w.webp"
    },
    {
      "id": "custom_7343b815-d13e-4188-8c25-00b1f5c6040c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-3afd-7142-a169-121462f3d2cc.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sofa, coffee table, bar stools, and dining chairs.",
        "public_id": "019fd91e-3afd-7142-a169-121462f3d2cc",
        "storage_key": "property/6767906449167015/019fd91e-3afd-7142-a169-121462f3d2cc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Brookbend Apartments Open-concept living area with kitchen bar, dining table, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/ec6d7c49df93af59e7a5097a0ac05c5a-1920w.webp"
    },
    {
      "id": "custom_50a7dfed-69de-4fed-8d38-8ffa61a550f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-3dc0-7760-9953-69212fefbe95.webp",
      "image_media": {
        "alt_text": "Living room and dining area with kitchen view",
        "public_id": "019fd91e-3dc0-7760-9953-69212fefbe95",
        "storage_key": "property/6767906449167015/019fd91e-3dc0-7760-9953-69212fefbe95.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living, dining, and kitchen area with modern appliances and ample counter space.",
      "link": "false",
      "alt_text": "Brookbend Apartments Open-concept living room and dining area with kitchen counter and appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/eb288dc083d8a5e2c27776e0e6895416-1920w.webp"
    },
    {
      "id": "custom_83bbee1c-06e7-427b-8c8f-055919a90a39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-4767-734b-9aad-4a58527fde5b.webp",
      "image_media": {
        "alt_text": "Modern dining area with a light marble-topped table and four woven chairs.",
        "public_id": "019fd91e-4767-734b-9aad-4a58527fde5b",
        "storage_key": "property/6767906449167015/019fd91e-4767-734b-9aad-4a58527fde5b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area, featuring a contemporary table, comfortable seating, and elegant wall art.",
      "link": "false",
      "alt_text": "Brookbend Apartments Dining area in an apartment with a table, wicker chairs, and a hallway to the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/6e62b96d9e14135cf26ee4c2f7b07dc7-1920w.webp"
    },
    {
      "id": "custom_d26989e6-d8b0-461b-9d63-ba94f6498c12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-4933-729f-8469-76580d4623fb.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with neutral gray carpeting and walls, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fd91e-4933-729f-8469-76580d4623fb",
        "storage_key": "property/6767906449167015/019fd91e-4933-729f-8469-76580d4623fb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen featuring stainless steel appliances and a convenient breakfast bar, perfect for any lifestyle.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment with neutral gray carpeting and walls, stainless steel appliances, and a breakfast bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-005-1920w.jpg"
    },
    {
      "id": "custom_2e903ce2-2d99-4099-9e13-b42149c448a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-48d1-7641-838b-6af712485b4e.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstands, closet, and artwork.",
        "public_id": "019fd91e-48d1-7641-838b-6af712485b4e",
        "storage_key": "property/6767906449167015/019fd91e-48d1-7641-838b-6af712485b4e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant nightstands, and ample closet space. Decorated with modern artwork for a relaxing ambiance.",
      "link": "false",
      "alt_text": "Brookbend Apartments Bedroom in a modern apartment with a bed, two nightstands, lamps, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/9531142271a778951cfc42409260eeb1-1920w.webp"
    },
    {
      "id": "custom_09504d76-6897-4ebc-9069-554551288f34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-4f1f-7635-999f-3f9dcda3b018.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, closet, and en-suite bathroom.",
        "public_id": "019fd91e-4f1f-7635-999f-3f9dcda3b018",
        "storage_key": "property/6767906449167015/019fd91e-4f1f-7635-999f-3f9dcda3b018.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Brookbend Apartments Bedroom with a queen bed, two nightstands, neutral tones, and a doorway to the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/5df5df0a8cbc48ae814382de27519387-1920w.webp"
    },
    {
      "id": "custom_d815d8aa-7e1c-459f-8ee7-371d77fd4d31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-52d8-73cb-abd5-84c529c4cdc3.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, bedside tables, and modern decor.",
        "public_id": "019fd91e-52d8-73cb-abd5-84c529c4cdc3",
        "storage_key": "property/6767906449167015/019fd91e-52d8-73cb-abd5-84c529c4cdc3.webp",
        "width": 1903,
        "height": 1268
      },
      "title": "Apartment",
      "description": "Relax in comfort in our spacious bedrooms, featuring plush bedding and elegant finishes for a truly restful experience.",
      "link": "false",
      "alt_text": "Stylish bedroom with a king-size bed, bedside tables, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/25-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-021+virtually+staged-1920w.jpeg"
    },
    {
      "id": "custom_b31d1c6e-e2f5-46ff-8e39-01553a5c9f32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-5357-721f-876b-8641dd433499.webp",
      "image_media": {
        "alt_text": "A tidy home office setup with a desk, chair, laptop, and shelving unit.",
        "public_id": "019fd91e-5357-721f-876b-8641dd433499",
        "storage_key": "property/6767906449167015/019fd91e-5357-721f-876b-8641dd433499.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this well-appointed home office, featuring a comfortable desk, modern chair, and ample shelving for all your needs.",
      "link": "false",
      "alt_text": "Brookbend Apartments Home office corner in a modern apartment with desk, chair, shelving, and plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/5767906449162442/6767906449167015/b70dd4491795a1a731179a1c73e14a18-1920w.webp"
    },
    {
      "id": "custom_a99f521c-5d12-422b-87a4-356801d47d8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-0cbf-75d3-b7a2-df68c4920f46.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "019fd91e-0cbf-75d3-b7a2-df68c4920f46",
        "storage_key": "property/6767906449167015/019fd91e-0cbf-75d3-b7a2-df68c4920f46.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "false",
      "link": "false",
      "alt_text": "false",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/35-web-or-mls-26+Cheswold+Blvd+Unit+12-1D-S0705-005-1920w.jpg"
    },
    {
      "id": "custom_c3c315c2-4434-4971-99a8-2a941358565c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-57a6-721d-be3b-a008f68c4581.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a closet and a window.",
        "public_id": "019fd91e-57a6-721d-be3b-a008f68c4581",
        "storage_key": "property/6767906449167015/019fd91e-57a6-721d-be3b-a008f68c4581.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and a large window, offering a bright and airy living space.",
      "link": "false",
      "alt_text": "Empty bedroom with a closet and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/28-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-024-1920w.jpg"
    },
    {
      "id": "custom_147586de-954d-413b-8afe-ae6e0d870e24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-5949-729f-85d9-1866b8ec1866.webp",
      "image_media": {
        "alt_text": "Kitchenette with white cabinets, speckled countertops, sink, microwave, stove, and refrigerator.",
        "public_id": "019fd91e-5949-729f-85d9-1866b8ec1866",
        "storage_key": "property/6767906449167015/019fd91e-5949-729f-85d9-1866b8ec1866.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A compact kitchenette featuring white cabinetry, a double sink, a microwave, a stove, and a refrigerator, perfect for a cozy apartment.",
      "link": "false",
      "alt_text": "Brookbend Apartments White kitchen with cabinets, stove, microwave, and sink; a fire extinguisher hangs on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/Brookbend-Apartments_020-1920w.jpg"
    },
    {
      "id": "custom_cd78aac8-e242-4b97-a8b4-565a912dcdd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-5e8e-74d5-896b-c72a8c4562e9.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances including a refrigerator, stove, microwave, and dishwasher, and a double sink.",
        "public_id": "019fd91e-5e8e-74d5-896b-c72a8c4562e9",
        "storage_key": "property/6767906449167015/019fd91e-5e8e-74d5-896b-c72a8c4562e9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wood cabinetry for storage, a full suite of white appliances including a refrigerator, stove, microwave, and dishwasher, and a double basin sink.",
      "link": "false",
      "alt_text": "Brookbend Apartments Kitchen with white appliances, wooden cabinets, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/Brookbend-Apartments_007-1920w.jpg"
    },
    {
      "id": "custom_ead286e5-82f3-42a3-870b-0513e6a3a69e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-5e67-7584-9786-4c7dd990bb9e.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white cabinets, marble countertop, black faucet, and a large mirror reflecting a shower.",
        "public_id": "019fd91e-5e67-7584-9786-4c7dd990bb9e",
        "storage_key": "property/6767906449167015/019fd91e-5e67-7584-9786-4c7dd990bb9e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with ample storage, a sleek marble countertop, and a large mirror. The clean design complements any apartment.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with white cabinets, marble countertop, black faucet, and a large mirror reflecting a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/18-web-or-mls-26+Cheswold+Blvd+Unit+6-3B-S0705-016-1920w.jpg"
    },
    {
      "id": "custom_d85dc43e-195d-4c21-8c3f-83673c20fea5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-61c1-76fd-9454-7a6ca72d7442.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a corner shower, toilet, and vanity with sink.",
        "public_id": "019fd91e-61c1-76fd-9454-7a6ca72d7442",
        "storage_key": "property/6767906449167015/019fd91e-61c1-76fd-9454-7a6ca72d7442.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Explore this modern bathroom featuring a sleek corner shower with frosted glass doors, a clean white toilet, and a convenient vanity with a sink.",
      "link": "false",
      "alt_text": "Modern bathroom with a corner shower, toilet, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/77-web-or-mls-26+Cheswold+Blvd+Unit+17-3B-S0705-029-1920w.jpg"
    },
    {
      "id": "custom_09e61f0b-2441-4707-96fb-0e622908a351",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-63f8-7339-a94e-cd2b59bd2029.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and picnic tables under a blue sky.",
        "public_id": "019fd91e-63f8-7339-a94e-cd2b59bd2029",
        "storage_key": "property/6767906449167015/019fd91e-63f8-7339-a94e-cd2b59bd2029.webp",
        "width": 1770,
        "height": 1180
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient picnic tables for a perfect day in the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and picnic tables under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/94-web-or-mls-Cheswold+Blvd-0705-915-df1cc399-1920w.jpg"
    },
    {
      "id": "custom_953a5a9f-030c-4052-8d80-eebde9af533c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-6a65-74dd-b7b6-421f880b0345.webp",
      "image_media": {
        "alt_text": "Picnic tables and grills in an outdoor seating area.",
        "public_id": "019fd91e-6a65-74dd-b7b6-421f880b0345",
        "storage_key": "property/6767906449167015/019fd91e-6a65-74dd-b7b6-421f880b0345.webp",
        "width": 1781,
        "height": 1187
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Picnic tables and grills in an outdoor seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/92-web-or-mls-Cheswold+Blvd-0705-913-1920w.jpg"
    },
    {
      "id": "custom_c543ced2-d558-4f89-a38c-f449459dac3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-6b82-73cc-af9a-204c041553fa.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structure in front of apartment buildings.",
        "public_id": "019fd91e-6b82-73cc-af9a-204c041553fa",
        "storage_key": "property/6767906449167015/019fd91e-6b82-73cc-af9a-204c041553fa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at the community playground, featuring a fun slide and climbing area perfect for children.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structure in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/91-web-or-mls-Cheswold+Blvd-0705-912-1920w.jpg"
    },
    {
      "id": "custom_5f9d08ff-bfcb-4491-84ed-dc12ded92ff4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-6c7c-74b0-b04e-a74aa784563f.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment, weight machines, and fitness accessories",
        "public_id": "019fd91e-6c7c-74b0-b04e-a74aa784563f",
        "storage_key": "property/6767906449167015/019fd91e-6c7c-74b0-b04e-a74aa784563f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a variety of cardio machines, weight training equipment, and accessories for a complete workout.",
      "link": "false",
      "alt_text": "Gym with cardio equipment, weight machines, and fitness accessories",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/88-web-or-mls-Cheswold+Blvd-0705-909-cbf2a27e-1920w.jpg"
    },
    {
      "id": "custom_85943cb7-b8c1-4f59-8fd9-00bc48d0db89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-71bc-706c-9137-eb87e36b3128.webp",
      "image_media": {
        "alt_text": "Fitness center with cable weight machines and trash receptacles.",
        "public_id": "019fd91e-71bc-706c-9137-eb87e36b3128",
        "storage_key": "property/6767906449167015/019fd91e-71bc-706c-9137-eb87e36b3128.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Fitness center with cable weight machines and trash receptacles.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/89-web-or-mls-Cheswold+Blvd-0705-910-1920w.jpg"
    },
    {
      "id": "custom_51531d70-313f-47ed-95c7-2cf7949302ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-77d5-732c-b35a-7db43143e51e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace, seating, and tables.",
        "public_id": "019fd91e-77d5-732c-b35a-7db43143e51e",
        "storage_key": "property/6767906449167015/019fd91e-77d5-732c-b35a-7db43143e51e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and ample space for work or socializing.",
      "link": "false",
      "alt_text": "Modern lounge area with fireplace, seating, and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/85-web-or-mls-Cheswold+Blvd-0705-906-1920w.jpg"
    },
    {
      "id": "custom_e745a338-2e41-46d0-9ad4-c66c0ca73ac6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-78c8-75be-94e6-afd8e3194e25.webp",
      "image_media": {
        "alt_text": "Community lounge area with tables, chairs, and a fireplace.",
        "public_id": "019fd91e-78c8-75be-94e6-afd8e3194e25",
        "storage_key": "property/6767906449167015/019fd91e-78c8-75be-94e6-afd8e3194e25.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our comfortable community lounge, featuring ample seating, a fireplace, and entertainment options.",
      "link": "false",
      "alt_text": "Community lounge area with tables, chairs, and a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/86-web-or-mls-Cheswold+Blvd-0705-907-1920w.jpg"
    },
    {
      "id": "custom_4209a827-af74-40c0-8a42-031762c18ba3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-79cb-7118-bbcf-3ecb6c6e0cac.webp",
      "image_media": {
        "alt_text": "Kitchenette with microwave, coffee maker, sink, and mini-fridge.",
        "public_id": "019fd91e-79cb-7118-bbcf-3ecb6c6e0cac",
        "storage_key": "property/6767906449167015/019fd91e-79cb-7118-bbcf-3ecb6c6e0cac.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A convenient kitchenette area equipped with a microwave, coffee maker, sink, and refrigerator, perfect for snacks and beverages.",
      "link": "false",
      "alt_text": "Kitchenette with microwave, coffee maker, sink, and mini-fridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/90-web-or-mls-Cheswold+Blvd-0705-911-1920w.jpg"
    },
    {
      "id": "custom_10c8f1fb-df15-4da1-8f8b-6af4a67c4b90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-7eb9-76ef-b6bd-90eead8748e4.webp",
      "image_media": {
        "alt_text": "Laundry room with two washing machines, a stacked dryer, and a folding table.",
        "public_id": "019fd91e-7eb9-76ef-b6bd-90eead8748e4",
        "storage_key": "property/6767906449167015/019fd91e-7eb9-76ef-b6bd-90eead8748e4.webp",
        "width": 1770,
        "height": 1180
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents, featuring multiple washing machines, dryers, and a folding counter for ease of use.",
      "link": "false",
      "alt_text": "Laundry room with two washing machines, a stacked dryer, and a folding table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/87-web-or-mls-Cheswold+Blvd-0705-908-1920w.jpg"
    },
    {
      "id": "custom_8a066e24-2388-4961-8bc0-2c8739383bf9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-8503-74be-886e-849c92e39e22.webp",
      "image_media": {
        "alt_text": "Mailboxes and package lockers under green awnings with apartment buildings in the background.",
        "public_id": "019fd91e-8503-74be-886e-849c92e39e22",
        "storage_key": "property/6767906449167015/019fd91e-8503-74be-886e-849c92e39e22.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Convenient mail and package pickup and drop-off available for residents at our apartment community. Features include secured package lockers and individual mailboxes.",
      "link": "false",
      "alt_text": "Mailboxes and package lockers under green awnings with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/80-web-or-mls-Cheswold+Blvd-0705-901-1920w.jpg"
    },
    {
      "id": "custom_ee992c64-b937-4608-b4de-d6d79147db59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-8595-716a-aaab-229ab9e70b26.webp",
      "image_media": {
        "alt_text": "Package lockers with charging stations nearby",
        "public_id": "019fd91e-8595-716a-aaab-229ab9e70b26",
        "storage_key": "property/6767906449167015/019fd91e-8595-716a-aaab-229ab9e70b26.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern package lockers offer secure and convenient delivery management, while nearby charging stations provide electric vehicle support for residents.",
      "link": "false",
      "alt_text": "Brookbend Apartments Outdoor parcel lockers with a control kiosk, located along the building exterior for resident package pickup.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/b68199262b6150bd24b6f94403d95507-56d08b94-1920w.jpg"
    },
    {
      "id": "custom_9f19c586-b836-4057-b41f-8141a90391a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-889d-7029-8f02-d4c529ef53c8.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging station with signage.",
        "public_id": "019fd91e-889d-7029-8f02-d4c529ef53c8",
        "storage_key": "property/6767906449167015/019fd91e-889d-7029-8f02-d4c529ef53c8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Charge your electric vehicle at our convenient charging station. This amenity is available for residents to use.",
      "link": "false",
      "alt_text": "OBrookbend Apartments on-site EV charging station in the property's exterior area, with signs indicating electric vehicle parking only.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/c08a8c1805e1e102a19f51315cd44070-9e1bb72f-1920w.jpg"
    },
    {
      "id": "custom_62333314-aeb8-4b12-b747-3a8ea50b045b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-8fe5-71e7-a74a-b5b39c1d0523.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a parking lot in front.",
        "public_id": "019fd91e-8fe5-71e7-a74a-b5b39c1d0523",
        "storage_key": "property/6767906449167015/019fd91e-8fe5-71e7-a74a-b5b39c1d0523.webp",
        "width": 1511,
        "height": 1007
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior of a brick apartment building with a parking lot in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/79-web-or-mls-VT-0705-2-1920w.jpg"
    },
    {
      "id": "custom_afb4d650-787e-4c59-a5f4-f6448cecfee8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-907e-7607-b598-c13094a41cf7.webp",
      "image_media": {
        "alt_text": "Brookbend Apartments monument sign",
        "public_id": "019fd91e-907e-7607-b598-c13094a41cf7",
        "storage_key": "property/6767906449167015/019fd91e-907e-7607-b598-c13094a41cf7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Brookbend Apartments, where comfort and convenience meet. Enjoy our beautifully landscaped grounds and welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Brookbend Apartments monument sign",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/efadd282/dms3rep/multi/opt/95-web-or-mls-Cheswold+Blvd-0705-916-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_32b3e402-f983-448a-9b13-b1e52e02841f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "127 Grove Ln, Newark, DE 19711, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers with a unique dipping sauce, alongside crispy fries and Texas toast. They also highlight the quick and friendly service, and the consistently fresh and hot food.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-9e59-711d-9ad9-1b715ffbc961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-9e59-711d-9ad9-1b715ffbc961",
        "storage_key": "property/6767906449167015/019d026f-9e59-711d-9ad9-1b715ffbc961.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/de/newark/127-grove-lane",
      "poi_directions_map_url": "https://maps.google.com/?cid=9881187619199695725&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.6799864",
      "poi_longitude": "-75.7354163",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-660-4399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-e467a1e286c2",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTk1U92rx4kRbbticckHIYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1b7ccee1-8df4-44e2-8c2d-349acc159f0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Main Event Newark",
      "poi_type": "Restaurants",
      "poi_address": "2900 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Video arcade, bowling alley, and laser tag center offering casual eats and cocktails.",
      "poi_long_description": "People say this restaurant offers bowling, arcade games, laser tag, and a ropes course. They also highlight the fun atmosphere and the friendly, attentive staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-9e27-77da-b7cc-3d4f157caff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-9e27-77da-b7cc-3d4f157caff2",
        "storage_key": "property/6767906449167015/019d026f-9e27-77da-b7cc-3d4f157caff2.webp",
        "width": 864,
        "height": 486
      },
      "poi_business_url": "http://www.mainevent.com/locations/delaware/newark",
      "poi_directions_map_url": "https://maps.google.com/?cid=8154670730405896827&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-newark",
      "poi_latitude": "39.6705497",
      "poi_longitude": "-75.6456515",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-722-9466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-e467a1e286c2",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6WFrADkBx4kRe2Ie8tI1K3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_69739bd6-e39a-42d1-b1a0-fd6a3bdf521b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "350 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious salmon, mashed potatoes, broccoli, and cheesecake. They also highlight the friendly staff, attentive service, and wide variety of menu options, including small plates and different cuisines.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026e-dbd2-7048-a57a-4c874ab555cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026e-dbd2-7048-a57a-4c874ab555cc",
        "storage_key": "property/6767906449167015/019d026e-dbd2-7048-a57a-4c874ab555cc.webp",
        "width": 1280,
        "height": 764
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/de/newark-151.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=11726206093432098982&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "39.6787384",
      "poi_longitude": "-75.6510922",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-454-9444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-e467a1e286c2",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____jz0Bx4kRppAKWlDau6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_da89613d-6243-4406-8237-2df491a7837a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "250 Buckley Blvd, Bear, DE 19701, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious hand-cut steaks, fall-off-the-bone ribs, and freshly made sides, with generous portions and flavorful food. They also highlight the fun, lively atmosphere, and the friendly, attentive, and quick service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-9e67-7612-afd6-bfb3339ffde1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-9e67-7612-afd6-bfb3339ffde1",
        "storage_key": "property/6767906449167015/019d026f-9e67-7612-afd6-bfb3339ffde1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/delaware/bear?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=17797951917119481311&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.6381575",
      "poi_longitude": "-75.64942959999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-322-3443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-e467a1e286c2",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcjWA-oGx4kR36VjlfgG__Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4f321ea7-2147-4823-8298-029b555791f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4657 Ogletown Stanton Rd, Newark, DE 19713, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves tasty chicken and fries. They highlight the food is often hot and fresh. They also like the quick service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a03a-73a8-8bb4-27a4cefaed7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a03a-73a8-8bb4-27a4cefaed7a",
        "storage_key": "property/6767906449167015/019d026f-a03a-73a8-8bb4-27a4cefaed7a.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/de/christiana?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10035972760374929105&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.6868111",
      "poi_longitude": "-75.6781427",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-737-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-e467a1e286c2",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-e467a1e286c2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8VjR-MAx4kR0eakfQ3wRos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ccc8a761-08a0-4033-a246-990cbfc3a141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Christiana Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "132 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Sizable venue with brand-name stores, a food court & sit-down restaurants, plus a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including major retailers and specialty shops, as well as a diverse food court with many dining options. They highlight the tax-free shopping, ample parking, and family-friendly atmosphere. They also like the convenient access from the highway and the presence of security.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d0270-ee52-73fd-bfd9-47225747e633.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0270-ee52-73fd-bfd9-47225747e633",
        "storage_key": "property/6767906449167015/019d0270-ee52-73fd-bfd9-47225747e633.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.christianamall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672530487854685918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiana-mall",
      "poi_latitude": "39.6782567",
      "poi_longitude": "-75.65185389999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-731-9816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-eae52fd540ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-eae52fd540ff",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-eae52fd540ff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFRln_T0Bx4kR3t5SmIcEW3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6241d5e6-ffb3-40cf-9921-707fa53ff4e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a unique selection of items, including a variety of organic foods, international flavors, and ready-to-eat meals, with their own branded products often being delicious and a great value. They also highlight the friendly, helpful, and efficient staff, as well as the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a2f1-75fc-9210-cdea433a8431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a2f1-75fc-9210-cdea433a8431",
        "storage_key": "property/6767906449167015/019d026f-a2f1-75fc-9210-cdea433a8431.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/de/newark/759/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13903272674461544209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.6731366",
      "poi_longitude": "-75.64803839999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-292-6825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573d-7688-a883-a2f44827a33c",
        "storage_key": "property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aagUD0Bx4kREe-ssNVY8sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6ff35c28-815b-4640-84be-f3a22ba87f8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Hung Vuong Food Market Delaware",
      "poi_type": "Shopping & Retail",
      "poi_address": "10 Geoffrey Dr Suite F, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "Shoppers say this Asian grocery store offers a wide variety of fresh produce, including fruits, vegetables, and an impressive selection of fish and seafood, as well as a diverse array of Asian products and sauces. They also highlight the delicious food court, which features boba tea, Vietnamese sandwiches, and roasted duck.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a35d-72fd-b4f5-09ab519e72c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a35d-72fd-b4f5-09ab519e72c3",
        "storage_key": "property/6767906449167015/019d026f-a35d-72fd-b4f5-09ab519e72c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hungvuongs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18210209861301674066&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hung-vuong-food-market-delaware",
      "poi_latitude": "39.6868022",
      "poi_longitude": "-75.6544479",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-294-6984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573d-7688-a883-a2f44827a33c",
        "storage_key": "property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdU7LYUBx4kRUqAzFGOpt_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_128f9f2f-bb74-47da-b5c2-e8df0e242611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Newark Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2515 Kirkwood Hwy, Newark, DE 19711, USA",
      "poi_short_description": "Multicultural supermarket (groceries or produce shop) with a variety of international foods, plus fresh seafood and other seafood from around the world.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, seafood, and international foods, including Asian, Indian, and Mexican options. They highlight the reasonable prices, especially for produce, and the diverse culinary experiences. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a4c2-750c-abd4-005cda46f4ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a4c2-750c-abd4-005cda46f4ad",
        "storage_key": "property/6767906449167015/019d026f-a4c2-750c-abd4-005cda46f4ad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://facebook.com/newarkfarmers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15543525558128142792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newark-farmers-market",
      "poi_latitude": "39.7056213",
      "poi_longitude": "-75.6879884",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 302-894-0895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573d-7688-a883-a2f44827a33c",
        "storage_key": "property/6767906449167015/019d026f-573d-7688-a883-a2f44827a33c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0mHDl8Ax4kRyOluWSSytdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_92524ed3-f766-4fc3-94a5-7004308727a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1301 New, Churchmans Rd, Newark, DE 19713, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a566-720b-9867-62f80b2e98a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a566-720b-9867-62f80b2e98a7",
        "storage_key": "property/6767906449167015/019d026f-a566-720b-9867-62f80b2e98a7.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Christiana/DE/Newark/19713/1601?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15175597474168299491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.6930544",
      "poi_longitude": "-75.6625344",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 302-369-6713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-573b-703f-ab4b-eae52fd540ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-573b-703f-ab4b-eae52fd540ff",
        "storage_key": "property/6767906449167015/019d026f-573b-703f-ab4b-eae52fd540ff.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI9zD_gIBx4kR498dvn-NmtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_63a21d68-1637-483a-8f54-474d724591be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "University of Delaware",
      "poi_type": "Education",
      "poi_address": "210 S College Ave, Newark, DE 19716, USA",
      "poi_short_description": "Public research school dating to 1743 & known for its science & engineering programs.",
      "poi_long_description": "Public research school dating to 1743 & known for its science & engineering programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-07a5-750a-99c5-5bb59a8c97f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-07a5-750a-99c5-5bb59a8c97f1",
        "storage_key": "property/6767906449167015/019d026f-07a5-750a-99c5-5bb59a8c97f1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.udel.edu/?utm_source=google&utm_medium=business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13848285473888854897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-delaware",
      "poi_latitude": "39.6809151",
      "poi_longitude": "-75.7523313",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-831-2792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d29-7739-85a7-866dee7ad533",
        "storage_key": "property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpelbVi6qx4kRceNYY0T-LsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2fd07157-b408-4f53-ad69-487d3f69950d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Wilmington University",
      "poi_type": "Education",
      "poi_address": "320 N Dupont Hwy, New Castle, DE 19720, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a930-7228-bc24-dc68a80945d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a930-7228-bc24-dc68a80945d5",
        "storage_key": "property/6767906449167015/019d026f-a930-7228-bc24-dc68a80945d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wilmu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16062612809978180469&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilmington-university",
      "poi_latitude": "39.6820414",
      "poi_longitude": "-75.5864299",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-356-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d29-7739-85a7-866dee7ad533",
        "storage_key": "property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1QxWSLADx4kRdXNjTz_d6d4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9dab8a13-e1f0-45bb-8219-0fca0483a0d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Delaware Technical Community College - Stanton Campus - Newark",
      "poi_type": "Education",
      "poi_address": "400 Stanton Christiana Rd d201, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a9a0-751e-ab75-bcf09d9830fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a9a0-751e-ab75-bcf09d9830fc",
        "storage_key": "property/6767906449167015/019d026f-a9a0-751e-ab75-bcf09d9830fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dtcc.edu/our-campuses/stanton",
      "poi_directions_map_url": "https://maps.google.com/?cid=15633881627870143609&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delaware-technical-community-college---stanton-campus---newark",
      "poi_latitude": "39.6891998",
      "poi_longitude": "-75.6487862",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-454-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d29-7739-85a7-866dee7ad533",
        "storage_key": "property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB_JnGBABx4kReaS0OYK09tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0b6f7c3a-779e-4c84-b0d6-9fc1b9bd4c23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Goldey-Beacom College",
      "poi_type": "Education",
      "poi_address": "4701 Limestone Rd, Wilmington, DE 19808, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a97f-70de-92c8-93930dc33283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a97f-70de-92c8-93930dc33283",
        "storage_key": "property/6767906449167015/019d026f-a97f-70de-92c8-93930dc33283.webp",
        "width": 1080,
        "height": 600
      },
      "poi_business_url": "http://www.gbc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5973550274496021678&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goldey-beacom-college",
      "poi_latitude": "39.7415725",
      "poi_longitude": "-75.6895335",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-998-8814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d29-7739-85a7-866dee7ad533",
        "storage_key": "property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvTJsYR8Ax4kRrsRFT1NQ5lI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b665474a-268c-40c0-8001-c0a0e25f7ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Bear Library",
      "poi_type": "Education",
      "poi_address": "101 Governors Pl, Bear, DE 19701, USA",
      "poi_short_description": "Peaceful library with a selection of books and magazines.",
      "poi_long_description": "People say this library offers a wide variety of resources, including books, computers, and a printer station. They highlight the peaceful and relaxing vibe, and the convenient location. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-a9f9-764c-9eac-fef8bc4037fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-a9f9-764c-9eac-fef8bc4037fe",
        "storage_key": "property/6767906449167015/019d026f-a9f9-764c-9eac-fef8bc4037fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.nccde.org/291/Bear-Library",
      "poi_directions_map_url": "https://maps.google.com/?cid=7397740606586100139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bear-library",
      "poi_latitude": "39.6354183",
      "poi_longitude": "-75.660061",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-838-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d29-7739-85a7-866dee7ad533",
        "storage_key": "property/6767906449167015/019d026f-5d29-7739-85a7-866dee7ad533.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB_0QmOYGx4kRqxkMBOMNqmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_2d41dfa9-d321-488a-8230-00d051a9c8d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Delaware Stadium",
      "poi_type": "Entertainment",
      "poi_address": "625 S College Ave, Newark, DE 19713, USA",
      "poi_short_description": "University home of the Delaware Blue Hens (Division I football team), this stadium features concession stands and friendly staff.",
      "poi_long_description": "People say this stadium offers a great atmosphere for watching games and seeing performances. They highlight the spacious seating, clean facilities, and friendly people. They also like the fun and exciting experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d0270-f2e1-74cd-94cf-ca0fe8c9d937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0270-f2e1-74cd-94cf-ca0fe8c9d937",
        "storage_key": "property/6767906449167015/019d0270-f2e1-74cd-94cf-ca0fe8c9d937.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.bluehens.com/ViewArticle.dbml?DB_OEM_ID=29100&ATCLID=209248469",
      "poi_directions_map_url": "https://maps.google.com/?cid=14879242534201834924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delaware-stadium",
      "poi_latitude": "39.6617428",
      "poi_longitude": "-75.7488224",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-831-2257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-d484-700c-902d-74dfe0db1880.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-d484-700c-902d-74dfe0db1880",
        "storage_key": "property/6767906449167015/019d026f-d484-700c-902d-74dfe0db1880.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyeZVwI-px4kRrL37UUCwfc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_24acd416-3db5-4da4-b780-e0a9d3961dab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Bob Carpenter Center",
      "poi_type": "Entertainment",
      "poi_address": "631 S College Ave, Newark, DE 19716, USA",
      "poi_short_description": "Huge setup for University of Delaware basketball & volleyball games plus concerts & banquets.",
      "poi_long_description": "People say this arena is clean and well-organized, with plenty of parking. They highlight the convenient location near major highways and the efficient restroom layout. They also like the friendly staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-1228-7576-9fe2-61511ee5a0f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-1228-7576-9fe2-61511ee5a0f1",
        "storage_key": "property/6767906449167015/019d026f-1228-7576-9fe2-61511ee5a0f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.udel.edu/bcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10243444412612742946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bob-carpenter-center",
      "poi_latitude": "39.6606674",
      "poi_longitude": "-75.7489776",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-831-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ5NJpupx4kRIg8-0msGKI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_602ecdbc-3b5f-442b-a960-39ff9033ec6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "211 Executive Dr #3, Newark, DE 19702, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-ae2c-73dc-a38a-081f6ddaca49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-ae2c-73dc-a38a-081f6ddaca49",
        "storage_key": "property/6767906449167015/019d026f-ae2c-73dc-a38a-081f6ddaca49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.skyzone.com/newark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4613580444609335361&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "39.6143118",
      "poi_longitude": "-75.74763589999999",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-449-1252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJac6YQ0Oox4kRQdCgd_i6BkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3c19f8f6-8ca4-42bf-b6ab-21b01c601fda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "531 W Main St, Christiana, DE 19702, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of attractions, including an arcade, and is a great place for birthday parties. They also highlight the friendly, helpful, and attentive staff, and the fun, energetic atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b03d-7732-b402-ee17894b0169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b03d-7732-b402-ee17894b0169",
        "storage_key": "property/6767906449167015/019d026f-b03d-7732-b402-ee17894b0169.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/delaware-christiana/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14885299305308812524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.6727069",
      "poi_longitude": "-75.66459189999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-223-5182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXnnA4sBx4kR7PRMPNo0k84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_927afed8-0b6f-49e3-8969-99b5ca398043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Fred P. Rullo Stadium",
      "poi_type": "Entertainment",
      "poi_address": "645 S College Ave, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-afff-755d-8939-658cf29ed1a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-afff-755d-8939-658cf29ed1a0",
        "storage_key": "property/6767906449167015/019d026f-afff-755d-8939-658cf29ed1a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluehens.com/ViewArticle.dbml?DB_OEM_ID=29100&ATCLID=209248095",
      "poi_directions_map_url": "https://maps.google.com/?cid=16596132304442153090&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fred-p-rullo-stadium",
      "poi_latitude": "39.6592693",
      "poi_longitude": "-75.7494826",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-285-4267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-d484-700c-902d-74dfe0db1880.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-d484-700c-902d-74dfe0db1880",
        "storage_key": "property/6767906449167015/019d026f-d484-700c-902d-74dfe0db1880.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy-OakJqpx4kRgtiom2ZOUeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_96ecf196-0930-4f83-b927-6ba85f92dae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "The Edge Fitness Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Limestone Rd, Wilmington, DE 19808, USA",
      "poi_short_description": "Members-only gym offering innovative programs, as well as a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, machines, and free classes, as well as personal training and massage services. They also highlight the reasonable membership rates, flexible hours, and the clean, well-maintained facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b335-7441-8ad4-f2cd5b767a4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b335-7441-8ad4-f2cd5b767a4b",
        "storage_key": "property/6767906449167015/019d026f-b335-7441-8ad4-f2cd5b767a4b.webp",
        "width": 607,
        "height": 1280
      },
      "poi_business_url": "https://www.theedgefitnessclubs.com/locations/delaware-pike-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=4088078166060044110&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-edge-fitness-clubs",
      "poi_latitude": "39.7387042",
      "poi_longitude": "-75.6917476",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-295-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGW0MK6IBx4kRTg8Ktm7Fuzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_39c247a7-ddc3-4a5f-98d2-f427776d2727",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Western Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2600 Capitol Tr, Newark, DE 19711, USA",
      "poi_short_description": "Nonprofit facility with indoor and outdoor pools, plus basketball, a sauna, and childcare.",
      "poi_long_description": "People say this gym offers a variety of workout equipment and classes, including pickleball and volleyball. They highlight the clean facilities, including the pools, and the spacious workout area with plenty of machines. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b335-7441-8ad4-efdf28330c86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b335-7441-8ad4-efdf28330c86",
        "storage_key": "property/6767906449167015/019d026f-b335-7441-8ad4-efdf28330c86.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcade.org/locations/western-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9274342308841419107&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "western-family-ymca",
      "poi_latitude": "39.7051779",
      "poi_longitude": "-75.6854075",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 302-709-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8xSeEV8Ax4kRY3HeOzEVtYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ffc9e9e0-75c0-4f37-a91f-839fb1fcbc92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "301 W Main St, Christiana, DE 19702, USA",
      "poi_short_description": "Chain fitness center in Christiana Town Center offering tanning and spa services, plus massage chairs.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines, including new skin-enhancing machines, and provides tools to help people reach their fitness goals. They highlight the clean and spacious facility, with updated locker rooms and ample parking, and the convenient location near other shopping spots. They also like the friendly, helpful, and professional staff, and the positive, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-2819-7516-adcd-b111f3ad0351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-2819-7516-adcd-b111f3ad0351",
        "storage_key": "property/6767906449167015/019d026f-2819-7516-adcd-b111f3ad0351.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/christiana-de?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9102138513706545596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.6688392",
      "poi_longitude": "-75.66608980000001",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-781-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJefXRbsoBx4kRvHHhxcBKUX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e21c477c-38ab-41a5-83cd-540bb67a3157",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "106 Geoffrey Dr, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b709-75ee-9e14-eb79dec0e138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b709-75ee-9e14-eb79dec0e138",
        "storage_key": "property/6767906449167015/019d026f-b709-75ee-9e14-eb79dec0e138.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/christiana-de/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6091693274673488598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "39.6871805",
      "poi_longitude": "-75.6497237",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-322-6933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWAyIeADx4kR1qKMFcIKilQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_dfecb4e9-63ac-4762-b2f1-9bfd323cdeee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Bear-Glasgow Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "351 George Williams Way, Newark, DE 19702, USA",
      "poi_short_description": "Clean sports facility, featuring an indoor pool and an outdoor pool, plus exercise classes for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b8b0-73f0-ab74-a8614dbce99c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b8b0-73f0-ab74-a8614dbce99c",
        "storage_key": "property/6767906449167015/019d026f-b8b0-73f0-ab74-a8614dbce99c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcade.org/locations/bear-glasgow-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16440345375663294436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bear-glasgow-family-ymca",
      "poi_latitude": "39.605539",
      "poi_longitude": "-75.732465",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 302-836-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zSGNBSox4kR5IcltQPXJ-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cc671d2b-a364-492a-9ee5-3371a92a7f3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Crunch Fitness - Newark",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Grove Ln, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide selection of fixed and free weights, as well as top-notch bikes, rowing, and step training gear. They also highlight the friendly, knowledgeable, and helpful staff, and the welcoming and supportive atmosphere.\n\nOther reviews mention the cancellation process can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-b8b8-724d-9e35-a00b86ef06da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-b8b8-724d-9e35-a00b86ef06da",
        "storage_key": "property/6767906449167015/019d026f-b8b8-724d-9e35-a00b86ef06da.webp",
        "width": 1225,
        "height": 800
      },
      "poi_business_url": "https://www.crunch.com/locations/newark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16558164109099067745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---newark",
      "poi_latitude": "39.6828366",
      "poi_longitude": "-75.7329117",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-366-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3MPJGirx4kRYel4P4dqyuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e626f61-17ee-477b-a91b-0a7f588c9d59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "900 Eden Cir, Bear, DE 19701, USA",
      "poi_short_description": "Chain health club with a swimming pool and basketball court, plus state-of-the-art equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including weights, machines, a pool, sauna, and group classes. They also highlight the friendly and welcoming staff, and the clean and well-maintained facilities.\n\nOther reviews mention the pool can be unavailable due to swim school classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-bc58-7368-83f4-6ceda1bf599f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-bc58-7368-83f4-6ceda1bf599f",
        "storage_key": "property/6767906449167015/019d026f-bc58-7368-83f4-6ceda1bf599f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1234&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16303867715030589060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "39.63213409999999",
      "poi_longitude": "-75.65768539999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-440-1378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xXOQu8Gx4kRhJ5bI075QuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4711e606-384c-490c-aa4d-e6dd7db2bf35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Lil Bob Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "Newark, DE 19711, USA",
      "poi_short_description": "Gym with a lap pool, diving well, and rock wall, plus basketball and volleyball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-bea0-7244-b5c4-82a379155f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-bea0-7244-b5c4-82a379155f8e",
        "storage_key": "property/6767906449167015/019d026f-bea0-7244-b5c4-82a379155f8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rec.bluehens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9053289574724110809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lil-bob-gym",
      "poi_latitude": "39.6842231",
      "poi_longitude": "-75.751385",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-831-2264",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2ak_jCqx4kR2Ykt3ua-o30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac4ce17e-cff7-4e25-8e55-d018a0025a59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Christiana Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4755 Ogletown Stanton Rd, Newark, DE 19718, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-1829-77fa-95d7-373353b4fad2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-1829-77fa-95d7-373353b4fad2",
        "storage_key": "property/6767906449167015/019d026f-1829-77fa-95d7-373353b4fad2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://christianacare.org/facilities/christianahospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495470270249753645&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiana-hospital",
      "poi_latitude": "39.6885738",
      "poi_longitude": "-75.67117739999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 302-733-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6319-7565-8d89-441780d34e76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6319-7565-8d89-441780d34e76",
        "storage_key": "property/6767906449167015/019d026f-6319-7565-8d89-441780d34e76.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbcdfuEAx4kRLdxAZdCu6-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c1ae31bb-15e8-4320-885c-51cdc1caef27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Wilmington VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 Kirkwood Hwy, Wilmington, DE 19805, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c08d-7769-8aa0-ecd0dc3eea31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c08d-7769-8aa0-ecd0dc3eea31",
        "storage_key": "property/6767906449167015/019d026f-c08d-7769-8aa0-ecd0dc3eea31.webp",
        "width": 828,
        "height": 828
      },
      "poi_business_url": "http://www.wilmington.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8026099408857117126&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilmington-va-medical-center",
      "poi_latitude": "39.7402129",
      "poi_longitude": "-75.60627319999999",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 302-994-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6319-7565-8d89-441780d34e76.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6319-7565-8d89-441780d34e76",
        "storage_key": "property/6767906449167015/019d026f-6319-7565-8d89-441780d34e76.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYIT3fD9xokRxrHmZONuYm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bccb021c-3df3-4ee0-84fe-6378f0ff888a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Deerfield",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "507 Thompson Station Rd, Newark, DE 19711, USA",
      "poi_short_description": "Long-running, public 18-hole course with pro shop plus a restaurant for drinks and breakfast.",
      "poi_long_description": "People say this public golf course offers a challenging layout with hilly terrain and blind shots, and the course conditions are excellent. They highlight the venue is beautiful and well-maintained, and the staff are helpful. They also like the spacious dining facilities and the good food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c111-7122-b944-617d5139f8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c111-7122-b944-617d5139f8bb",
        "storage_key": "property/6767906449167015/019d026f-c111-7122-b944-617d5139f8bb.webp",
        "width": 1268,
        "height": 845
      },
      "poi_business_url": "https://deerfieldgolfclub.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8204111526729788179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "deerfield",
      "poi_latitude": "39.7185764",
      "poi_longitude": "-75.7506774",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-368-6640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-d48d-71f2-8f21-932745b56586.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-d48d-71f2-8f21-932745b56586",
        "storage_key": "property/6767906449167015/019d026f-d48d-71f2-8f21-932745b56586.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQ4tLuWqx4kRE6tqYPfb2nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5826d9a6-787f-41e7-9d01-5226e4a873b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Delcastle Recreational Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2920 Duncan Rd, Wilmington, DE 19808, USA",
      "poi_short_description": "Public park with 400 acres of space, including an 18-hole golf course, ball fields & walking trail.",
      "poi_long_description": "People say this park offers a playground, softball fields, and a walking trail. They highlight the spacious open areas, ample seating, and well-maintained grounds. They also like the friendly atmosphere and the availability of parking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c345-70ed-a487-6e610743df64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c345-70ed-a487-6e610743df64",
        "storage_key": "property/6767906449167015/019d026f-c345-70ed-a487-6e610743df64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nccde.org/Facilities/Facility/Details/Delcastle-Recreational-Park-66",
      "poi_directions_map_url": "https://maps.google.com/?cid=15951953184655779193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "delcastle-recreational-park",
      "poi_latitude": "39.7428035",
      "poi_longitude": "-75.6600157",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-395-5606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6215-7309-9de1-42e54bf02247",
        "storage_key": "property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-jr7Sj-xokReaURhee4YN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3100682d-b3a6-434a-8eff-d0bef8ebb04d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "White Clay Creek State Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1475 Creek Rd, Newark, DE 19711, USA",
      "poi_short_description": "Nature preserve offering hiking, fishing, picnic opportunities, and wildlife viewing.",
      "poi_long_description": "People say this nature preserve offers many trails for hiking and biking, as well as a delayed harvest trout stream. They highlight the lovely scenery, peaceful trails, and fun for families. They also like the range of walking and hiking abilities catered to, with both paved and dirt paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c479-71ba-aa03-75f3afeda2de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c479-71ba-aa03-75f3afeda2de",
        "storage_key": "property/6767906449167015/019d026f-c479-71ba-aa03-75f3afeda2de.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://destateparks.com/WhiteClayCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=2795990864502286955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "white-clay-creek-state-park-nature-center",
      "poi_latitude": "39.7272266",
      "poi_longitude": "-75.7680085",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-368-6560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6215-7309-9de1-42e54bf02247",
        "storage_key": "property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZG8mxurx4kRa2rloeBazSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e36b05ac-804a-491e-ba80-522749522f96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Banning Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "102 Middleboro Rd, Wilmington, DE 19804, USA",
      "poi_short_description": "Park featuring ball diamonds, soccer fields & tennis courts, plus a wooded area & a playground.",
      "poi_long_description": "Park featuring ball diamonds, soccer fields & tennis courts, plus a wooded area & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c519-76fc-83aa-1ca41e52623c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c519-76fc-83aa-1ca41e52623c",
        "storage_key": "property/6767906449167015/019d026f-c519-76fc-83aa-1ca41e52623c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nccde.org/Facilities/Facility/Details/Banning-Regional-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=16924456291450064327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banning-regional-park",
      "poi_latitude": "39.7215718",
      "poi_longitude": "-75.5903148",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 302-395-5606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6215-7309-9de1-42e54bf02247",
        "storage_key": "property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbX8wOGwCx4kRx42B1FO_3-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0fd0335-6412-4adb-8c13-9ec062ef0854",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "White Clay Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Park Office, 750 Thompson Station Rd, Newark, DE 19711, USA",
      "poi_short_description": "Park featuring 37 miles of hiking & biking trails along with fishing streams & a nature center.",
      "poi_long_description": "People say this state park offers beautiful hiking trails, fishing spots, and opportunities for mountain biking and disc golf. They highlight the park's natural beauty, diverse trails with varying difficulty levels, and areas near water for enjoyment. They also like the well-marked trails, clean environment, and convenient amenities such as parking and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-1472-72fe-8197-f8944bd7b5b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-1472-72fe-8197-f8944bd7b5b0",
        "storage_key": "property/6767906449167015/019d026f-1472-72fe-8197-f8944bd7b5b0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.destateparks.com/park/white-clay-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17516642154323962018&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "white-clay-creek-state-park",
      "poi_latitude": "39.7348663",
      "poi_longitude": "-75.7580196",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-368-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-6215-7309-9de1-42e54bf02247",
        "storage_key": "property/6767906449167015/019d026f-6215-7309-9de1-42e54bf02247.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Q5sP_2qx4kRougccjudF_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_7151900f-fa71-4b9a-9b1b-4f436d359067",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Wilmington Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Dupont Hwy, New Castle, DE 19720, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this airport offers convenient parking and easy access to the gate. They also highlight the friendly staff and reasonable prices.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-c7cf-7258-af99-c9133ae36c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-c7cf-7258-af99-c9133ae36c65",
        "storage_key": "property/6767906449167015/019d026f-c7cf-7258-af99-c9133ae36c65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyilg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1083455709425976738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wilmington-airport",
      "poi_latitude": "39.6790169",
      "poi_longitude": "-75.60703960000001",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-325-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-d64e-7790-b677-05060d01834f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-d64e-7790-b677-05060d01834f",
        "storage_key": "property/6767906449167015/019d026f-d64e-7790-b677-05060d01834f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJMbyqscQDx4kRokU0Mjo1CQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2e54ad3e-f4c8-420d-8130-23dd969e9ac2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Newark",
      "poi_type": "Transportation & Transit",
      "poi_address": "10 Mopar Dr, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-3dc9-723e-8979-639e7aa15909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-3dc9-723e-8979-639e7aa15909",
        "storage_key": "property/6767906449167015/019d026f-3dc9-723e-8979-639e7aa15909.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=NRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=10072551141323619632&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "newark",
      "poi_latitude": "39.6697081",
      "poi_longitude": "-75.7535305",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-66a1-716c-80a7-3e1836398e8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-66a1-716c-80a7-3e1836398e8f",
        "storage_key": "property/6767906449167015/019d026f-66a1-716c-80a7-3e1836398e8f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJVeSwaoepx4kRML2MeOXjyIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_4a13667b-4aca-448d-a109-5238b35d09b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Churchman's Crossing",
      "poi_type": "Transportation & Transit",
      "poi_address": "Delaware 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-cab0-714c-a22a-775cce839ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-cab0-714c-a22a-775cce839ce2",
        "storage_key": "property/6767906449167015/019d026f-cab0-714c-a22a-775cce839ce2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/m/stations/rail/churchmans.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9155545375220360384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "churchmans-crossing",
      "poi_latitude": "39.6944296",
      "poi_longitude": "-75.6730312",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-66a1-716c-80a7-3e1836398e8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-66a1-716c-80a7-3e1836398e8f",
        "storage_key": "property/6767906449167015/019d026f-66a1-716c-80a7-3e1836398e8f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJuRo9cPwAx4kRwOT6tgIID38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2e23075f-ed77-44bd-9cd8-3d8a275a7709",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "CSC Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "251 Little Falls Dr, Wilmington, DE 19808, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-ca78-77dd-8270-5d527c6b37ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-ca78-77dd-8270-5d527c6b37ba",
        "storage_key": "property/6767906449167015/019d026f-ca78-77dd-8270-5d527c6b37ba.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.cscglobal.com/cscglobal/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6174308801920788182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "csc-headquarters",
      "poi_latitude": "39.761157",
      "poi_longitude": "-75.6228546",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 302-636-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2rzPwv-xokR1mYOeCSNr1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_babd5c6b-c92f-420f-b3a8-5e5e2f0f7658",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "JP Morgan Chase & Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Stanton Christiana Rd, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-cbc2-750c-a462-d77c2f80cf3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-cbc2-750c-a462-d77c2f80cf3b",
        "storage_key": "property/6767906449167015/019d026f-cbc2-750c-a462-d77c2f80cf3b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jpmorgan.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10569161979913522864&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jp-morgan-chase--co",
      "poi_latitude": "39.6938828",
      "poi_longitude": "-75.6485667",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8a7CgwBx4kRsE5PqtI0rZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_221b9fb2-c30f-4349-ba9c-7050e1233282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Bank of America Newark Campus (Corporate)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Samoset Dr, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-ccc9-749f-ad01-bf7d012612db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-ccc9-749f-ad01-bf7d012612db",
        "storage_key": "property/6767906449167015/019d026f-ccc9-749f-ad01-bf7d012612db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bankofamerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3769409176702328166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bank-of-america-newark-campus-corporate",
      "poi_latitude": "39.6834376",
      "poi_longitude": "-75.6757107",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 888-550-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg9y2A-cAx4kRZp1wzqyhTzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_851b2d92-1553-4873-b6a1-42d2b252a4a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "FinTech Building, STAR Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "591 Collaboration Way, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-cf0b-77ea-aea3-d2fef9463787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-cf0b-77ea-aea3-d2fef9463787",
        "storage_key": "property/6767906449167015/019d026f-cf0b-77ea-aea3-d2fef9463787.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://deltechpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16272382136536271296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fintech-building-star-campus",
      "poi_latitude": "39.66323",
      "poi_longitude": "-75.7574975",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-452-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYgDEe-px4kRwAmooVYd0-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_51c4bdfd-92a3-4a4a-a35c-dd268507739f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "poi_name": "Siemens Healthcare Diagnostics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 GBC Dr, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-cf26-769b-8daf-a38122cbad9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026f-cf26-769b-8daf-a38122cbad9b",
        "storage_key": "property/6767906449167015/019d026f-cf26-769b-8daf-a38122cbad9b.webp",
        "width": 1280,
        "height": 596
      },
      "poi_business_url": "https://www.siemens-healthineers.com/en-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=9857652478370021073&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "siemens-healthcare-diagnostics",
      "poi_latitude": "39.6167346",
      "poi_longitude": "-75.7412207",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-631-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026f-5d8d-74cf-a5b5-fe483e74688a",
        "storage_key": "property/6767906449167015/019d026f-5d8d-74cf-a5b5-fe483e74688a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWEn2kCox4kR0X5-dLNqzYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f01f6a59-4046-42c0-a37d-4d134a11dd37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_61635371-e0bd-47e8-add1-ec870827aa99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c1b0c5be-192d-4afa-b99c-095bba35c789",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c926ef9f-5331-4007-bc36-13e637e370d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d540d6c9-bd61-481d-80f7-08dafdb6453f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_773c4210-2f2a-4961-ba32-0d389a83ae79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9d58951b-cbc0-44b2-857c-54ff0d7a603c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "rating": "5.0",
      "name": "Kimberly Fitzsimmons",
      "text": "I've lived at harbor club for several years and I love it here. I appreciate the way the staff care about the property and the tenants. They are always on top of everything. The grounds are clean. They do a lot of upkeep to maintain the parking lots, tow disabled cars, and keep the grounds looking nice. The manager, Brenda, and the rest of the office staff are very helpful and caring if I ever have a problem.  I would recommend Harbor Club Apartments to anyone looking for an apartment.",
      "date": "2025-03-04",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_844dceae-24a0-459d-bdbe-04b8e6cb75f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-0cbf-75d3-b7a2-df68c4920f46.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-0cbf-75d3-b7a2-df68c4920f46",
        "storage_key": "property/6767906449167015/019fd91e-0cbf-75d3-b7a2-df68c4920f46.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Renovated Studio - 281 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://www.zillow.com/view-imx/a69c7b9d-ad97-48c8-b052-1ebc2a78d03d?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    },
    {
      "id": "custom_42e2f5aa-c656-4b41-8807-5022efe205bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-0c47-745a-ad2d-c615183d72cb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-0c47-745a-ad2d-c615183d72cb",
        "storage_key": "property/6767906449167015/019fd91e-0c47-745a-ad2d-c615183d72cb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 735SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MdpSx8FUqAR"
    },
    {
      "id": "custom_9cbf07e0-86d9-4f68-960e-0bf5957b21bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-12e0-73bb-ac42-dcc3df9b74fc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-12e0-73bb-ac42-dcc3df9b74fc",
        "storage_key": "property/6767906449167015/019fd91e-12e0-73bb-ac42-dcc3df9b74fc.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Renovated 2BR 1BA",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://www.zillow.com/view-imx/ec937dac-1ffd-44cd-925c-756a0efaa152?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    },
    {
      "id": "custom_7c0349d5-9dd3-44c9-b04c-c1340b2689b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-12a9-719d-a16b-15b3dd102efd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-12a9-719d-a16b-15b3dd102efd",
        "storage_key": "property/6767906449167015/019fd91e-12a9-719d-a16b-15b3dd102efd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 890SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gXuv8njuY1K"
    },
    {
      "id": "custom_8f6f4752-3649-4d41-b934-fd793ae78e1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-1850-7109-a120-643227293713.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-1850-7109-a120-643227293713",
        "storage_key": "property/6767906449167015/019fd91e-1850-7109-a120-643227293713.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 800SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EuzYEqSDfLi"
    },
    {
      "id": "custom_5dd63f83-634d-4787-9c3f-af7df599c9c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-18d2-7693-8634-920f969cab77.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-18d2-7693-8634-920f969cab77",
        "storage_key": "property/6767906449167015/019fd91e-18d2-7693-8634-920f969cab77.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 890 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5AYKZ4gFGmj"
    },
    {
      "id": "custom_18e179b8-26d1-4f09-97e4-b693b6004410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-1d9c-75f5-94fa-6de4a82cd99c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-1d9c-75f5-94fa-6de4a82cd99c",
        "storage_key": "property/6767906449167015/019fd91e-1d9c-75f5-94fa-6de4a82cd99c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1071SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xpm3UHt4FoC"
    },
    {
      "id": "custom_4070f8eb-c58c-4a55-8551-b013bc14bf60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/019fd91e-1e3a-7518-a34c-7bdf171dc533.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd91e-1e3a-7518-a34c-7bdf171dc533",
        "storage_key": "property/6767906449167015/019fd91e-1e3a-7518-a34c-7bdf171dc533.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=k9aUhNE1ub4"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_fa5226679d73ff99a4d73e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576168",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2923c62fb80714900f357ab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576169",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0156123cb612d5e2384e13f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576170",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_01a7a14afa178f187c2757d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576171",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_de14e1b238035718a2e06e5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576172",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eb4cf48248c95eb0b94ed435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576173",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_521ee96a97d379a042b33d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "576174",
      "name": "Pet Deposit",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_e8928c7d3ee77760c256e479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "582661",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_de652a62f69324fac75604aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "582662",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_b40689f06931912b3bb8e3f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "582663",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_10116086d42b327318651c69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "832562",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6effd5476a4d7967f092c227",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "832571",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fe76201a60d52121afe91798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "835304",
      "name": "Late Fee",
      "description": "5% late fee, per occurrence.",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1c5dbe2891cb5929c9dce2e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "835307",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fb073e47c7f1dace4e74c6b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "835311",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2747bcd613a0c5090253acdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "835313",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_421f1851bbf082642e9df230",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "engrain",
      "external_id": "835325",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c6d6a-eb9c-7061-b96c-94eb02aae17c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-brookbend",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-newark-de-994",
      "search_query": "apartments with air conditioning Newark DE",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Newark, DE",
      "h2_subtitle": "Discover apartments with air conditioning in Newark, DE. Experience ultimate comfort at Brookbend, offering modern layouts and excellent amenities.",
      "page_copy": "Experience comfortable living at Brookbend, where every apartment is designed with air conditioning in Newark, DE, to ensure a pleasant atmosphere year-round. Choose from a variety of spacious floor plans, including one, two, or three-bedroom options, tailored to fit your lifestyle needs. \n\nLocated in the heart of Newark, DE, at Brookbend, you'll enjoy a host of modern amenities alongside air-conditioned living spaces. Take advantage of our refreshing pool, fully-equipped fitness center, and scenic walking trails. Our pet-friendly community also features a convenient Parcel Pending Package Center and a diligent on-site property manager, ensuring peace of mind and convenience for all residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Newark, DE | Brookbend",
      "seo_description": "Discover air-conditioned apartments in Newark, DE at Brookbend. Enjoy comfort with modern amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-new-castle-809",
      "search_query": "pet-friendly apartments with dog park New Castle County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in New Castle County",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in New Castle County. Brookbend offers ideal amenities for you and your furry friend.",
      "page_copy": "Welcome to Brookbend in Upper New Castle County, where pet-friendly living meets exceptional amenities, including an on-site dog park. Our community is perfect for both you and your furry companions, offering apartment layouts of one, two, or three bedrooms tailored to ensure everyone's comfort. \n\nBeyond our dedicated dog park, residents of Brookbend can enjoy scenic walking trails for an invigorating stroll, making it a haven for pet lovers. With features like a parcel center and a proactive on-site property manager, our apartments provide convenience and peace for all residents and their pets. Discover your ideal pet-friendly home today at Brookbend!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments & Dog Park in New Castle",
      "seo_description": "Find pet-friendly apartments with a dog park in New Castle County at Brookbend. Enjoy a welcoming home for you and your pets today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "brookbend-apartments-fitness-center-795",
      "search_query": "Brookbend apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Brookbend Apartments with Fitness Center",
      "h2_subtitle": "Discover sleek Brookbend apartments featuring a state-of-the-art fitness center. Your fitness journey starts here in Newark, DE.",
      "page_copy": "At Brookbend in Newark, DE, our apartments are not just homes but a lifestyle hub, featuring a modern fitness center perfect for maintaining an active lifestyle. Whether you prefer intense workouts or just adding exercise to your day, our facility is designed to complement your routine.\n\nApart from the fitness center, living at Brookbend means access to superior amenities, including a sparkling pool, a pet play area, and serene walking trails. Each apartment, available in one, two, or three-bedroom floor plans, is meticulously designed for your comfort and convenience. Contact us today to experience how Brookbend can enhance your living experience!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brookbend Apartments with Fitness Center in Newark",
      "seo_description": "Enjoy Brookbend apartments in Newark with a top-notch fitness center. Discover comfortable living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-with-pool-newark-19713-843",
      "search_query": "apartments with pool Newark 19713",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Newark 19713",
      "h2_subtitle": "Find beautiful apartments with a pool in Newark, 19713. Brookbend offers leisure and luxury for all residents.",
      "page_copy": "Welcome to Brookbend, where our stunning apartments in Newark, 19713 come complete with a refreshing pool, providing the perfect retreat on those warm summer days. Offering a selection of one, two, or three-bedroom apartments, Brookbend is designed to suit various lifestyle needs while ensuring comfort and convenience.\n\nLocated in the vibrant community of Newark, DE, residents also have access to fantastic amenities like a fitness center and scenic walking trails. Our pet-friendly environment features a dedicated pet play area, and a Parcel Pending Package Center makes picking up deliveries hassle-free. Come see what makes Brookbend the perfect community for work and relaxation!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Newark, DE 19713 | Brookbend",
      "seo_description": "Discover apartments with a pool in Newark, 19713 at Brookbend. Enjoy excellent amenities and beautiful surroundings today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "scenic-walking-trails-brookbend-newark-97",
      "search_query": "scenic walking trails at Brookbend Newark",
      "category": "Amenity",
      "h1_title": "Scenic Walking Trails at Brookbend",
      "h2_subtitle": "Explore the scenic walking trails at Brookbend in Newark. Enjoy serene pathways perfect for strolls and jogs.",
      "page_copy": "Nestled in the heart of Newark, DE, Brookbend offers residents access to beautiful scenic walking trails that wind through the community. These trails provide a perfect escape for morning jogs, leisurely evening strolls, or simply enjoying nature right outside your doorstep.\n\nBrookbend isn’t just about picturesque trails; our community provides a host of amenities including a swimming pool, a cutting-edge fitness center, and pet-friendly areas. Apartment options of one, two, or three bedrooms are designed to enhance comfort and style. Discover how Brookbend combines the tranquility of nature with modern living conveniences. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scenic Walking Trails in Newark | Brookbend Apartments",
      "seo_description": "Experience the scenic walking trails at Brookbend in Newark. Enjoy peaceful walks and a host of amenities in our beautiful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-newark-de-500",
      "search_query": "one bedroom apartments newark de",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Newark, DE",
      "h2_subtitle": "Discover charming one bedroom apartments in Newark, DE at Brookbend. Perfectly designed for comfort and style.",
      "page_copy": "Brookbend in Newark, DE offers beautifully designed one-bedroom apartments that cater to comfortable and stylish living. Each unit is thoughtfully planned with a modern kitchen, cozy living spaces, and elegant window coverings, providing a welcoming atmosphere.\n\nBeyond the walls of your new home, enjoy access to excellent amenities. Relax by the swimming pool, stay active in the fitness center, or take a leisurely stroll along our scenic trails. At Brookbend, we aim to create a community that enhances your lifestyle. Explore our one-bedroom options, where convenience meets contemporary design. Contact us today to learn more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Newark, DE | Brookbend",
      "seo_description": "Explore one bedroom apartments in Newark, DE at Brookbend. Enjoy comfort, style, and exceptional amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-upper-new-castle-county-575",
      "search_query": "two bedroom apartments upper new castle county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Upper New Castle",
      "h2_subtitle": "Find spacious two bedroom apartments in Upper New Castle County. Brookbend offers modern living and superb amenities.",
      "page_copy": "At Brookbend, discover inviting two-bedroom apartments located in the desirable Upper New Castle County. These thoughtfully designed spaces offer the perfect blend of style and functionality, featuring modern kitchens, ample living areas, and plenty of natural light through well-placed window coverings.\n\nBeyond the living space, residents have access to first-rate amenities such as a sparkling swimming pool, a state-of-the-art fitness center, and picturesque walking trails. Additionally, the community is pet-friendly and offers a convenient Parcel Pending Package Center. Embrace a lifestyle of comfort and convenience at Brookbend, nestled in Newark’s vibrant setting. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Upper New Castle County",
      "seo_description": "Discover two bedroom apartments in Upper New Castle County at Brookbend. Enjoy spacious layouts and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-19713-10",
      "search_query": "three bedroom apartments near 19713",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 19713",
      "h2_subtitle": "Discover spacious three bedroom apartments near 19713. Brookbend offers stylish living and modern conveniences.",
      "page_copy": "Located in Newark, DE, Brookbend provides spacious three-bedroom apartments near the 19713 area code, ideal for families or those needing extra space. Each apartment is crafted with comfort in mind, boasting stylish interiors, modern kitchens, and ample storage, ensuring a cozy yet functional living environment.\n\nResidents enjoy access to an array of superior amenities, including a refreshing pool, a fully-equipped fitness center, and picturesque walking trails perfect for leisure and exercise. Situated in a prime location, Brookbend gives you the best of both worlds: a peaceful community with easy access to local attractions. Come and see why our three-bedroom apartments are perfect for you – schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 19713 | Brookbend",
      "seo_description": "Explore three bedroom apartments near 19713 at Brookbend. Enjoy spacious layouts and excellent amenities in Newark, DE.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-delaware-newark-526",
      "search_query": "apartments near university of delaware newark",
      "category": "School",
      "h1_title": "Apartments Near University of Delaware",
      "h2_subtitle": "Find convenient apartments near the University of Delaware in Newark. Experience comfortable and modern living at Brookbend.",
      "page_copy": "Brookbend in Newark, DE is the perfect home base for students and staff of the University of Delaware, offering modern apartments just a short distance from campus. Our community features one, two, and three-bedroom floor plans, each designed to provide a balance of comfort and convenience with modern kitchens and inviting living spaces.\n\nEnhance your lifestyle with our range of amenities, including a sparkling pool for relaxation, a fitness center for staying active, and scenic walking trails for unwinding. Our proximity to the University of Delaware and other local features makes Brookbend a highly sought-after residence. Elevate your living experience in a community that thrives on convenience and style. Visit us to learn more!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Delaware Newark",
      "seo_description": "Discover convenient apartments near the University of Delaware in Newark at Brookbend. Enjoy modern living close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-close-to-wilmington-university-de-23",
      "search_query": "apartments close to wilmington university de",
      "category": "School",
      "h1_title": "Apartments Close to Wilmington University, DE",
      "h2_subtitle": "Discover ideal apartments close to Wilmington University, DE. Brookbend offers modern living with great amenities.",
      "page_copy": "Located conveniently near Wilmington University, DE, Brookbend offers the perfect apartments for students and faculty looking for a comfortable and modern living environment. Choose from spacious one, two, or three-bedroom layouts, each designed with contemporary styles and features such as well-equipped kitchens and ample living spaces.\n\nResidents enjoy a host of community amenities, including a refreshing pool, a state-of-the-art fitness center, and scenic walking trails—perfect for unwinding after a long day on campus. With on-site management and a convenient Parcel Pending Package Center, Brookbend makes apartment living stress-free and enjoyable. Come explore what makes us an ideal choice for those studying and working at Wilmington University. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Wilmington University, DE",
      "seo_description": "Find modern apartments close to Wilmington University, DE. Enjoy stylish living with convenient amenities at Brookbend in Newark.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-near-delaware-technical-community-college-newark-245",
      "search_query": "apartments near delaware technical community college newark",
      "category": "School",
      "h1_title": "Apartments Near Delaware Tech Newark Campus",
      "h2_subtitle": "Explore comfortable apartments near Delaware Technical Community College in Newark. Brookbend offers convenience and amenities for students.",
      "page_copy": "Situated just a short drive from Delaware Technical Community College in Newark, Brookbend provides an ideal living solution for students seeking convenience and comfort. Our community features versatile one, two, and three-bedroom apartment options, each designed to offer a modern and stress-free living environment, with fully equipped kitchens and generous living areas.\n\nAt Brookbend, residents can enjoy a range of amenities designed to enhance their living experience, including a refreshing swimming pool, a fitness center equipped with the latest exercise machines, and beautifully maintained walking trails. With a prime location near campus and all these conveniences, Brookbend is an excellent choice for those attending Delaware Tech. Schedule a tour today and see why our apartments are the perfect fit for your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Delaware Tech Newark",
      "seo_description": "Find comfortable apartments near Delaware Technical Community College in Newark. Enjoy modern amenities and convenience at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-by-goldey-beacom-college-new-castle-county-326",
      "search_query": "apartments by goldey-beacom college in new castle county",
      "category": "School",
      "h1_title": "Apartments by Goldey-Beacom College",
      "h2_subtitle": "Discover stylish apartments by Goldey-Beacom College in New Castle County. Brookbend offers modern living with convenient amenities.",
      "page_copy": "Brookbend offers ideal living accommodations in New Castle County, perfectly situated for students and staff of Goldey-Beacom College. Choose from thoughtfully designed one, two, and three-bedroom apartments, each geared towards providing comfort and modern convenience. With sleek kitchens and ample living spaces, our apartments are perfect for those seeking proximity to campus life.\n\nResidents at Brookbend enjoy an array of amenities, including a maintained fitness center, a refreshing pool, and beautiful walking trails, making it easy to find balance between work, school, and leisure. Plus, our neighborhood provides quick access to Goldey-Beacom College and the broader educational community. Discover a lifestyle designed with you in mind at Brookbend and schedule your tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Goldey-Beacom College",
      "seo_description": "Stylish apartments near Goldey-Beacom College in New Castle County. Enjoy modern living and amenities at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-near-christiana-hospital-newark-de-740",
      "search_query": "apartments near Christiana Hospital Newark DE",
      "category": "Hospital",
      "h1_title": "Apartments Near Christiana Hospital, Newark DE",
      "h2_subtitle": "Find conveniently located apartments near Christiana Hospital in Newark, DE. Brookbend offers modern amenities for comfortable living.",
      "page_copy": "Brookbend is located in close proximity to Christiana Hospital in Newark, DE, providing an ideal living situation for healthcare professionals and their families. Choose from our selection of spacious one, two, and three-bedroom floor plans, each designed with contemporary living in mind, featuring modern kitchens and comfortable living spaces.\n\nResidents enjoy a tranquil community feel with amenities including a fitness center, a refreshing swimming pool, and picturesque walking trails. With the added benefit of on-site management and a Parcel Pending Package Center, Brookbend ensures a seamless living experience. Experience the convenience and comfort of Brookbend and discover why it's the perfect location near Christiana Hospital. Schedule a tour today to see all we have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Christiana Hospital, Newark DE",
      "seo_description": "Conveniently located apartments near Christiana Hospital in Newark, DE. Enjoy modern living and amenities at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-close-to-wilmington-va-medical-center-new-castle-county-512",
      "search_query": "apartments close to Wilmington VA Medical Center New Castle County",
      "category": "Hospital",
      "h1_title": "Apartments Near Wilmington VA Medical Center",
      "h2_subtitle": "Explore comfortable living options close to Wilmington VA Medical Center in New Castle County. Experience modern amenities at Brookbend.",
      "page_copy": "Brookbend offers a convenient living solution close to the Wilmington VA Medical Center in New Castle County. Our community is perfect for healthcare professionals and veterans looking for modern and accessible accommodation. Choose from spacious one, two, or three-bedroom apartments featuring fully equipped kitchens and ample living areas designed for comfort and functionality.\n\nResidents can enjoy a host of amenities, including a state-of-the-art fitness center, a sparkling swimming pool, and peaceful walking trails, ensuring a balanced lifestyle. With our community's strategic location near the Wilmington VA Medical Center, commuting is hassle-free, providing more time for relaxation and enjoying the well-curated facilities at Brookbend. Visit us today to find out why our apartments are your perfect home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wilmington VA Medical Center",
      "seo_description": "Find modern apartments close to Wilmington VA Medical Center in New Castle County. Enjoy amenities and comfort at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "apartments-near-delcastle-recreational-park-newark-913",
      "search_query": "apartments near Delcastle Recreational Park Newark",
      "category": "Park",
      "h1_title": "Apartments Near Delcastle Recreational Park",
      "h2_subtitle": "Discover apartments near Delcastle Recreational Park in Newark. Live close to nature and enjoy fantastic amenities at Brookbend.",
      "page_copy": "Brookbend offers prime residential options near Delcastle Recreational Park in Newark. Our spacious one, two, and three-bedroom apartments provide easy access to the great outdoors, offering a prime location for those who love recreational activities. Whether you're looking for a serene setting or active lifestyle, our community accommodates all.\n\nExperience the best of both worlds with amenities such as a modern fitness center, a refreshing pool, and scenic walking trails only minutes away from the expansive Delcastle Recreational Park. Brookbend's proximity to this beautiful park makes it easy for residents to enjoy picnics, hiking, and sports activities. Visit us today and find out why our community is the perfect choice for anyone looking to live near nature while enjoying a vibrant living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Delcastle Recreational Park",
      "seo_description": "Find apartments near Delcastle Recreational Park in Newark. Enjoy nature and modern living at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "brookbend-apartments-near-white-clay-creek-state-park-487",
      "search_query": "Brookbend apartments close to White Clay Creek State Park Nature Center",
      "category": "Park",
      "h1_title": "Brookbend Apartments Near White Clay Creek",
      "h2_subtitle": "Experience nature up close with Brookbend apartments near White Clay Creek State Park Nature Center. Enjoy the best of outdoor and modern living.",
      "page_copy": "At Brookbend, you'll find a perfect blend of modern living and natural beauty, with our apartments situated near White Clay Creek State Park Nature Center. Offering convenient access to scenic trails and outdoor activities, our community is ideal for nature enthusiasts and those who enjoy an active lifestyle.\n\nChoose from our well-designed one, two, or three-bedroom apartments that feature all the comforts of home, such as fully equipped kitchens, ample living spaces, and stylish finishes. Our on-site amenities, including a fitness center, pool, and pet play area, enhance the living experience for all residents. Embrace the tranquility of nature and the convenience of modern life at Brookbend, just minutes away from the beloved White Clay Creek State Park Nature Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Brookbend Apartments Near White Clay Creek",
      "seo_description": "Live near White Clay Creek State Park Nature Center at Brookbend. Enjoy nature and modern comforts in Newark.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "rental-properties-near-banning-regional-park-de-349",
      "search_query": "rental properties near Banning Regional Park DE",
      "category": "Park",
      "h1_title": "Rental Properties Near Banning Regional Park",
      "h2_subtitle": "Explore rental properties near Banning Regional Park in DE. Enjoy outdoor fun and modern amenities at Brookbend.",
      "page_copy": "Brookbend offers ideal rental properties located conveniently close to Banning Regional Park in Delaware. Our community is perfect for those who love the great outdoors and appreciate easy access to recreational spaces. Settle into our comfortable one, two, or three-bedroom apartments, each designed with modern conveniences and ample living areas.\n\nResidents can take advantage of our excellent amenities, such as a fitness center, sparkling pool, and pet-friendly spaces, all just a short drive from Banning Regional Park. This offers a perfect opportunity for outdoor enthusiasts who want the freedom of nearby picnics, walking trails, and green spaces. Discover the balance of nature and contemporary living at Brookbend, a welcoming community near Banning Regional Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Properties Near Banning Regional Park",
      "seo_description": "Find rental properties near Banning Regional Park DE. Enjoy outdoor activities and modern comforts at Brookbend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449167015",
      "source": "custom",
      "page_item_url": "upper-new-castle-apartments-near-white-clay-creek-66",
      "search_query": "Upper New Castle County apartments near White Clay Creek State Park",
      "category": "Park",
      "h1_title": "Upper New Castle Apartments Near White Clay Creek",
      "h2_subtitle": "Discover Upper New Castle County apartments near White Clay Creek State Park. Enjoy serene nature views and modern comforts at Brookbend.",
      "page_copy": "Nestled in Upper New Castle County, Brookbend offers beautiful apartments conveniently near White Clay Creek State Park. This location is perfect for those who crave both nature and contemporary living. Our spacious one, two, and three-bedroom floor plans provide residents with the essentials for a comfortable lifestyle, all set in a serene environment.\n\nEnjoy direct access to the lush landscapes and extensive trails of White Clay Creek State Park from our community. At Brookbend, you’ll find top-notch amenities such as a fitness center, outdoor pool, and a parcel pending package center to enhance your living experience. Experience the ideal combination of tranquility and convenience in our well-appointed apartment homes in Upper New Castle County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "01a015d9-4285-7754-b756-c522db1a6a73",
        "storage_key": "property/6767906449167015/01a015d9-4285-7754-b756-c522db1a6a73.webp",
        "width": 1280,
        "height": 720
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Upper New Castle Apartments Near White Clay Creek",
      "seo_description": "Upper New Castle County apartments near White Clay Creek State Park. Enjoy tranquil living at Brookbend with modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5984"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10834289758"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5618406"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRD4SV4L"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livebrookbendapartments.fatwin.com/api/websites/resources/1?x=QUpnZzYxNjgzTUc1Q1JuUnN6enY5VVJxZnRlZEJFbnZUUkN0alVuZTNWbDlXTVpHaHkzSkVteW1XRXJOUjlWUkxRbm1ycmZGc2RGSk10eU5FMFRwN0E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47668258328"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "d3627960-fe2c-11f0-af7f-db8cf49ca098"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/d3627960-fe2c-11f0-af7f-db8cf49ca098/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/d3627960-fe2c-11f0-af7f-db8cf49ca098/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImsvczVUUkdRamMyQzdsSG5VMGYxMWc9PSIsInZhbHVlIjoiMHlWL3BNOFZ0cC96WVpTT2ZkRXZaUT09IiwibWFjIjoiYTNhYTYwY2I2ZGFjZGVmN2RkZDBiNmExNzcyNjdjNTUyM2IyNGMyMjUyZjc3M2VkNzFmOTM4ZDc4NTljMGU1YSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5984",
  "custom_repli_id": "10834289758",
  "custom_realpage_id": "5618406",
  "custom_google_gtm_id": "GTM-NRD4SV4L",
  "custom_perq_script_url": "https://livebrookbendapartments.fatwin.com/api/websites/resources/1?x=QUpnZzYxNjgzTUc1Q1JuUnN6enY5VVJxZnRlZEJFbnZUUkN0alVuZTNWbDlXTVpHaHkzSkVteW1XRXJOUjlWUkxRbm1ycmZGc2RGSk10eU5FMFRwN0E9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "47668258328",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "d3627960-fe2c-11f0-af7f-db8cf49ca098",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/d3627960-fe2c-11f0-af7f-db8cf49ca098/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/d3627960-fe2c-11f0-af7f-db8cf49ca098/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImsvczVUUkdRamMyQzdsSG5VMGYxMWc9PSIsInZhbHVlIjoiMHlWL3BNOFZ0cC96WVpTT2ZkRXZaUT09IiwibWFjIjoiYTNhYTYwY2I2ZGFjZGVmN2RkZDBiNmExNzcyNjdjNTUyM2IyNGMyMjUyZjc3M2VkNzFmOTM4ZDc4NTljMGU1YSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "7b87d259-5eaa-4012-8283-13f3614785ea",
  "custom_audioeye_site_hash": "4ca9c7b3ddf8d46f61f48abc081c8250"
};

export const generatedAt = '2026-11-02T16:59:09.589Z';
